var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg047Boots = function Svg047Boots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.98 362c-3.902 18.153-6.101 36.63-6.101 55.313V422h90v-15c0-24.814-20.186-45-45-45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M466.361 422c-2.64-34.188-27.68-62.393-60.009-67.617l-34.043-10.854c-52.866-8.804-88.912-57.731-82.324-110.493L307.617 90H55.12l15.489 141.409c4.102 36.929 1.084 70.225-8.979 98.965-.187.536-.309 1.089-.493 1.626h30.742c41.353 0 75 33.647 75 75v15zM46.879 452h420v60h-420zM51.788 60h259.581l7.502-60H45.121z"
  })));
};
export default Svg047Boots;